import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskNumber'
})
export class MaskNumberPipe implements PipeTransform {

  transform(number, maskCount: number): unknown {
    
    if (!number || maskCount <= 0) {
      return number; // Return as is if no masking is needed
    }
    const value = number.toString();
    const maskedPart = value
      .substring(0, maskCount)
      .replace(/\d/g, '*'); // Replace specified number of digits with '*'
    const remainingPart = value.substring(maskCount); // Keep the rest unchanged
    return maskedPart + remainingPart;
  }
  

}
